import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helper } from 'src/app/helper/defult';
import { HttpIOService } from 'src/app/services/http-io.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PopupConfirmationComponent } from 'src/app/container/elements/popup-confirmation/popup-confirmation.component';
import { DynamicSnacbarErrorComponent } from 'src/app/container/elements/dynamic-snacbar-error/dynamic-snacbar-error.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'app-unlock-workforce',
  templateUrl: './unlock-workforce.component.html',
  styleUrls: ['./unlock-workforce.component.scss']
})
export class UnlockWorkforceComponent implements OnInit {
  userDetailsForm: FormGroup;
  emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9_.+-]{2,}$/;
  namePattern = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
  numberPattern = /^\+?\d+$/;
  showTYpage: boolean = false;

  // recruitment process cards data
  recruit_process = [
    {
      photo: '../../../../assets/images/orange-single-person-icon.webp',
      title: 'Executive Recruitment',
      para: 'Secure high-impact leadership talent.',
    },
    {
      photo: '../../../../assets/images/orange-plural-persons-icon.webp',
      title: 'Mass Recruitment',
      para: 'Rapidly scale your workforce with top candidates.',
    },
    {
      photo: '../../../../assets/images/orange-notes-icon.webp',
      title: 'Contract Staffing',
      para: 'Get skilled professionals for short-term projects.',
    },
    {
      photo: '../../../../assets/images/orange-briefcase-icon.webp',
      title: 'Remote Workforce',
      para: 'Hire remote talent for roles across your business.',
    },
  ]

  // Simplify Workforce Cards Data
  simplify_wf = [
    {
      photo: '../../../../assets/images/orange-calendar-icon.webp',
      title: 'Temporary Staffing',
      para: 'Quick hires to meet urgent needs.',
    },
    {
      photo: '../../../../assets/images/orange-plural-persons-icon.webp',
      title: 'Permanent Placement',
      para: 'Long-term talent for core roles.',
    },
    {
      photo: '../../../../assets/images/orange-paper-icon.webp',
      title: 'Payroll & HR Outsourcing',
      para: 'We manage the details so you don\'\t have to.',
    },
    {
      photo: '../../../../assets/images/orange-briefcase-icon.webp',
      title: 'Remote Teams',
      para: 'Build efficient virtual teams from anywhere.',
    },
  ]

  recruit = [
    {
      title: 'Quick Recruitment',
      para: 'Get qualified candidates in 3–5 working days.',
    },
    {
      title: 'Industry Expertise',
      para: 'Proven success across multiple sectors.',
    },
    {
      title: 'Tailored Solutions',
      para: 'Services designed to meet your needs.',
    },
    {
      title: 'Compliance Covered',
      para: 'We handle legal and regulatory details.',
    },
    {
      title: 'Cost-Effective',
      para: 'Save time and reduce overhead.',
    },
  ]

  // Clients saying
  client_say = [
    {
      quote: '"WorkNigeria provided exceptional recruitment services for our senior roles, and we couldn\'\t be more satisfied with the results. They demonstrated a deep understanding of our company\'\s needs and took the time to find candidates who not only had the right skills but also aligned with our organizational culture. Their process was professional, efficient, and transparent, with excellent communication throughout. Thanks to WorkNigeria, we\'\ve successfully filled several key senior positions with top-tier talent who are already making a positive impact on our business..."',
      naam: 'Rafiat',
      company: 'TA Team, Rite Foods',
    },
    {
      quote: 'Worknigeria exceeded our expectations in recruiting top-notch middle-level talent for our company. Their expertise, thorough screening process, and understanding of our needs ensured we hired highly skilled professionals. The candidates are a perfect fit, contributing immediately to our success. Highly recommend their recruitment services!"--Bridgehead Engineering ',
      naam: 'HR Jonathan',
      company: 'Bridgehead Engineering',
    },
    {
      quote: 'Worknigeria did an amazing job handling our bulk recruitment. Efficient, professional, and found great talent quickly. Highly recommended!"- Activedge Technologies',
      naam: 'Head of HR, Mr Kenneth',
      company: 'Activedge Technologies',
    },
    {
      quote: 'Worknigeria has been fantastic in recruiting engineers for Textron Engineering. Their professionalism and attention to detail are impressive!',
      naam: 'Mr Joseph, MD/CEO, ',
      company: 'Textron Engineering',
    },
  ]

  constructor(
    private fb: FormBuilder,
    private helper: Helper,
    private io: HttpIOService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    this.userDetailsForm = this.fb.group({
      fullName: ['', [Validators.required, Validators.pattern(this.namePattern)]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      phoneNumber: ['', [Validators.required, Validators.pattern(this.numberPattern)]],
      path: ['/brochure-email', Validators.required],
      type: ['workforce', Validators.required],
      consent: [false, Validators.requiredTrue],
    });
  }

  extractFirstLetter(text: string): string {
    // Common titles or prefixes to ignore
    const ignoreWords = ['mr', 'mrs', 'ms', 'miss', 'dr', 'head', 'of', 'hr'];

    // Split text by spaces
    const words = text.trim().split(/\s+/);

    // Find the first word that is not a title
    const name = words.find(word => !ignoreWords.includes(word.toLowerCase()));

    // Return the first letter of that name (uppercase)
    return name ? name[0].toUpperCase() : '';
  }

  get f() {
    return this.userDetailsForm.controls;
  }

  scrollToForm() {
    const element = <HTMLElement>document.querySelector(`#userDetailsFormDiv`);
    element.scrollIntoView({ behavior: 'smooth' });
  }

  submitForm() {
    if (this.userDetailsForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.userDetailsForm);
      return false;
    }
    this.io._saveUserData(this.userDetailsForm.value).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        let successData = 'workforce manage confirms';
        this.router.navigate(['/form-submitted']);
      } else {
        this.snackBar
          .openFromComponent(DynamicSnacbarErrorComponent, {
            data: res.serverResponse.message,
            verticalPosition: 'top', // 'top' | 'bottom'
            horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
          })
          .afterOpened()
          .subscribe(this.helper.setOnTop);
      }
    })
  }
}
